import {NgModule} from '@angular/core';
import {AvatarModule} from 'primeng/avatar';
import {TagModule} from 'primeng/tag';
import {ChipModule} from 'primeng/chip';
import {ListboxModule} from 'primeng/listbox';
import {MegaMenuModule} from 'primeng/megamenu';
import {TreeSelectModule} from 'primeng/treeselect';
import {DividerModule} from 'primeng/divider';
import {DropdownModule} from 'primeng/dropdown';
import {PaginatorModule} from "primeng/paginator";
import {CardModule} from "primeng/card";
import {SkeletonModule} from "primeng/skeleton";
import {TableModule} from "primeng/table";
import {TabViewModule} from "primeng/tabview";
import {AutoCompleteModule} from "primeng/autocomplete";
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {AnimateModule} from 'primeng/animate';
import {TooltipModule} from 'primeng/tooltip';
import {ToolbarModule} from 'primeng/toolbar';
import {SplitButtonModule} from 'primeng/splitbutton';
import {BadgeModule} from 'primeng/badge';
import {ContextMenuModule} from 'primeng/contextmenu';
import {MenuModule} from 'primeng/menu';
import {ToastModule} from 'primeng/toast';
import {RippleModule} from "primeng/ripple";
import {KeyFilterModule} from 'primeng/keyfilter';
import {AutoFocusModule } from 'primeng/autofocus';
import {DataViewModule} from "primeng/dataview";
import {SplitterModule} from 'primeng/splitter';
import {CarouselModule} from 'primeng/carousel';
import {GalleriaModule} from 'primeng/galleria';
import {DialogModule} from 'primeng/dialog';
import { ImageModule } from 'primeng/image';
import {OverlayPanelModule } from 'primeng/overlaypanel';
import {VirtualScrollerModule} from "primeng/virtualscroller";
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import {PanelModule} from 'primeng/panel';import {CheckboxModule} from 'primeng/checkbox';
@NgModule({
  declarations: [],
  imports: [
    AvatarModule,
    TagModule,
    ChipModule,
    ListboxModule,
    MegaMenuModule,
    TreeSelectModule,
    DividerModule,
    DropdownModule,
    PaginatorModule,
    CardModule,
    SkeletonModule,
    TableModule,
    TabViewModule,
    ButtonModule,
    AutoCompleteModule,
    InputTextModule,
    DropdownModule,
    AnimateModule,
    TooltipModule,
    ToolbarModule,
    SplitButtonModule,
    BadgeModule,
    ContextMenuModule,
    MenuModule,
    ToastModule,
    RippleModule,
    KeyFilterModule,
    AutoFocusModule,
    DataViewModule,
    SplitterModule,
    CarouselModule,
    GalleriaModule,
    DialogModule,
    OverlayPanelModule,
    ImageModule,
    VirtualScrollerModule,
    ScrollPanelModule,
    RadioButtonModule,
    PanelModule,
    CheckboxModule,
  ],
  exports: [
    AvatarModule,
    TagModule,
    ChipModule,
    ListboxModule,
    MegaMenuModule,
    TreeSelectModule,
    DividerModule,
    DropdownModule,
    PaginatorModule,
    CardModule,
    SkeletonModule,
    TableModule,
    TabViewModule,
    ButtonModule,
    AutoCompleteModule,
    InputTextModule,
    AnimateModule,
    TooltipModule,
    ToolbarModule,
    SplitButtonModule,
    BadgeModule,
    ContextMenuModule,
    MenuModule,
    ToastModule,
    RippleModule,
    KeyFilterModule,
    AutoFocusModule,
    DataViewModule,
    SplitterModule,
    CarouselModule,
    GalleriaModule,
    DialogModule,
    OverlayPanelModule,
    ImageModule,
    VirtualScrollerModule,
    ScrollPanelModule,
    RadioButtonModule,
    PanelModule,
    CheckboxModule,
  ]
})
export class PrimengModule {
}
